var map = {
	"./athletic-crop-top_fabric.svg": 515489,
	"./beanie_lining-color.svg": 167388,
	"./canvas_canvas-frame.svg": 130113,
	"./classic-crewneck_color.svg": 399197,
	"./classic-pullover-hoodie_color.svg": 391473,
	"./comfort-long-sleeve-t-shirt_color.svg": 415706,
	"./comfort-racerback-tank-top_color.svg": 941326,
	"./comfort-slimfit-t-shirt_color.svg": 605837,
	"./comfort-t-shirt_color.svg": 559254,
	"./cropped-pullover-hoodie_color.svg": 212256,
	"./dad-cap-with-printed-patch_color.svg": 218511,
	"./day-tote_strap-color.svg": 281082,
	"./fitted-polo-shirt_color.svg": 412660,
	"./fitted-skirt_fabric.svg": 106024,
	"./flare-skirt_fabric.svg": 494300,
	"./flow-pullover-hoodie_color.svg": 776025,
	"./flow-racerback-tank-top_color.svg": 51138,
	"./holiday-stocking_loop-color.svg": 249368,
	"./kimono-robe_trim-belt.svg": 261277,
	"./makeup-bag_zipper-color.svg": 536897,
	"./makeup-bag_zipper-pull copy.svg": 416276,
	"./market-tote_fabric.svg": 143455,
	"./market-tote_strap-color.svg": 966344,
	"./market-tote_style/basic.svg": 107380,
	"./market-tote_style/market.svg": 649322,
	"./market-tote_style/none.svg": 852888,
	"./origami-tote_strap-color.svg": 188042,
	"./peignoir_trim-belt.svg": 339740,
	"./pet-bowl_finish/glossy.svg": 465056,
	"./pet-bowl_finish/matte.svg": 132466,
	"./pet-bowl_finish/none.svg": 853601,
	"./premium-crewneck_color.svg": 73128,
	"./premium-long-sleeve-t-shirt_color.svg": 117173,
	"./premium-pullover-hoodie_color.svg": 914842,
	"./premium-slimfit-t-shirt_color.svg": 662130,
	"./premium-t-shirt_color.svg": 674481,
	"./premium-unisex-tank-top_color.svg": 828539,
	"./premium-zipper-hoodie_color.svg": 561841,
	"./ruffle-scrunchie_fabric.svg": 46699,
	"./scarf_fabric.svg": 544027,
	"./snapback-with-printed-patch_color.svg": 221000,
	"./spiral-notebook_frosted-polymer-cover/none.svg": 482235,
	"./spiral-notebook_frosted-polymer-cover/with-cover.svg": 639791,
	"./spiral-notebook_frosted-polymer-cover/without-cover.svg": 854669,
	"./spiral-notebook_spiral-color.svg": 483277,
	"./square-scarf_fabric.svg": 817289,
	"./stainless-steel-tumbler_finish/glossy.svg": 746240,
	"./stainless-steel-tumbler_finish/matte.svg": 818386,
	"./stainless-steel-tumbler_finish/none.svg": 235137,
	"./stainless-steel-water-bottle_finish/glossy.svg": 571413,
	"./stainless-steel-water-bottle_finish/matte.svg": 845705,
	"./stainless-steel-water-bottle_finish/none.svg": 827004,
	"./thread-color.svg": 29744,
	"./tote-bag_strap-color.svg": 859312,
	"./tote-bag_style/basic.svg": 656828,
	"./tote-bag_style/none.svg": 472176,
	"./tote-bag_style/urban.svg": 240286,
	"./unisex-joggers_color.svg": 696734,
	"./unisex-polo-shirt_color.svg": 584962,
	"./vegan-leather-backpack_color.svg": 638328,
	"./vegan-leather-crossbody-purse_color.svg": 199716,
	"./vegan-leather-makeup-bag_color.svg": 61666,
	"./vegan-leather-tote-bag_color.svg": 858689,
	"./wrap-skirt_wrap-tie-color.svg": 711508,
	"./yoga-shorts_fabric.svg": 148270,
	"./zipper-carry-all_zipper-color.svg": 929139,
	"./zipper-carry-all_zipper-pull.svg": 785659,
	"./zipper-color.svg": 202098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504448;